import React, { useState } from 'react';
import './PropertyWizard.css';

/**
 * AgentCard Component
 * 
 * Displays information about an agent and provides actions:
 * - View details
 * - Assign/unassign properties
 * - Rate agent
 * - Remove agent
 */
function AgentCard({ relation, onAssignProperty, onRate, onRemove }) {
  const [showRating, setShowRating] = useState(false);
  const [rating, setRating] = useState(parseFloat(relation.owner_rating) || 0);

  const agent = relation.agent_details;
  const statusLabels = {
    'assigned': { label: 'اختصاص داده شده', color: '#8a6d00' },
    'accepted': { label: 'پذیرفته شده', color: '#287a45' },
    'rejected': { label: 'رد شده', color: '#b23a48' },
    'completed': { label: 'تکمیل شده', color: '#246b76' }
  };

  const status = statusLabels[relation.status] || statusLabels['assigned'];

  const handleRateSubmit = () => {
    onRate(relation.id, rating);
    setShowRating(false);
  };

  const renderRatingOptions = () => {
    return [1, 2, 3, 4, 5].map(value => (
      <button
        type="button"
        key={value}
        className={`rating-option ${value === rating ? 'selected' : ''}`}
        onClick={() => setRating(value)}
        aria-pressed={value === rating}
      >
        {value}
      </button>
    ));
  };

  return (
    <div className="agent-card">
      <div className="agent-header">
        <div className="agent-photo-container">
          {agent.profile_image ? (
            <img 
              src={agent.profile_image} 
              alt={agent.full_name}
              className="agent-photo"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <div className="agent-photo-placeholder" style={{ display: agent.profile_image ? 'none' : 'flex' }} />
        </div>
        <div className="agent-info">
          <h4 className="agent-name">{agent.full_name}</h4>
          <div className="agent-rating">
            <span className="rating-value">
              {relation.owner_rating ? `${parseFloat(relation.owner_rating).toFixed(1)}/5` : 'بدون امتیاز'}
            </span>
          </div>
        </div>
      </div>

      <div className="agent-details">
        <div className="agent-detail-row">
          <span className="detail-text">تلفن: {agent.phone || 'تعریف نشده'}</span>
        </div>
        <div className="agent-detail-row">
          <span className="detail-text">ایمیل: {agent.email || 'تعریف نشده'}</span>
        </div>
        <div className="agent-detail-row">
          <span className="detail-text">{relation.assigned_properties_count} ملک اختصاص داده شده</span>
        </div>
        <div className="agent-detail-row">
          <span className="detail-text" style={{ color: status.color }}>
            وضعیت: {status.label}
          </span>
        </div>
      </div>

      {showRating && (
        <div className="rating-modal">
          <h5>امتیاز دهی به نماینده</h5>
          <div className="rating-stars">
            {renderRatingOptions()}
          </div>
          <div className="rating-actions">
            <button className="rating-submit" onClick={handleRateSubmit}>
              ثبت امتیاز
            </button>
            <button className="rating-cancel" onClick={() => setShowRating(false)}>
              انصراف
            </button>
          </div>
        </div>
      )}

      <div className="agent-actions">
        <button
          className="agent-action-button assign-button"
          onClick={() => onAssignProperty(relation.id)}
          title="اختصاص ملک"
        >
          اختصاص ملک
        </button>
        <button
          className="agent-action-button rate-button"
          onClick={() => setShowRating(true)}
          title="امتیاز دهی"
        >
          امتیاز
        </button>
        <button
          className="agent-action-button remove-button"
          onClick={() => onRemove(relation.id, agent.full_name)}
          title="حذف نماینده"
        >
          حذف
        </button>
      </div>
    </div>
  );
}

export default AgentCard;
